<template>
  <el-dialog v-loading="isLoading" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh"
    :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">{{`${paymentDesc}支付`}}</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <div class="cs-qrCodeViewer-top">
        <div class="cs-qrCodeViewer-explain">
          <i v-if="!!paymentImgList[paymentKey]" class="icon" aria-hidden="true">
            <img :src="paymentImgList[paymentKey]" />
          </i>
          <span>{{`请打开${paymentDesc}扫一扫，扫描二维码`}}</span>
        </div>
        <span v-if="!!tips" class="cs-qrCodeViewer-tips" v-html="tips" />
      </div>
      <div v-if="!Object.isEmpty(this.createOrderResponse)" class="cs-qrCodeViewer-main">
        <div v-if="createOrderResponse.PayApiType === GLOBAL.enumPayApiType.AlphaPay">
          <div v-if="!isPaied">
            <div>
              <img :src="createOrderResponse.QRCodeImage" />
            </div>
            <h4>
              <b>
                <span>付款金额({{createOrderResponse.Currency}})：</span>
                <span>{{createOrderResponse.PaymentAmount / 100|toCurrency}}</span>
              </b>
            </h4>
            <div>
              <span>订单编号：</span>
              <span>{{createOrderResponse.OrderId}}</span>
            </div>
            <div>
              <span>商户订单编号：</span>
              <span>{{createOrderResponse.RequestId}}</span>
            </div>
            <div>
              <span>备注：</span>
              <span>{{createOrderResponse.Description}}</span>
            </div>
          </div>
          <div v-else>
            <iframe class="alphaPay-content" scrolling="no" frameborder="no" :src="resUrl" />
          </div>
        </div>
        <div v-else>
          <iframe class="checkpay-content" scrolling="no" frameborder="no" :src="createOrderResponse.PayUrl" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { getPaymentImgList } from "@/config/mUtils.js";
import {
  createPaymentOrder,
  getAlphaPayOrderRecordByWorkflowId,
} from "@/service/common.service";

const mixin_WindowEvents = {
  created() {
    window.addEventListener("message", this.receiveMsg);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMsg);
  },
  methods: {
    receiveMsg(event) {
      if (!this.createOrderResponse || Object.isEmpty(this.createOrderResponse))
        return;

      const data = event.data;
      switch (data.cmd) {
        case "checkpay": {
          if (
            data.params.success &&
            data.params.merchantOrderId ===
              this.createOrderResponse.RequestId
          ) {
            this.$emit("success", data.params.merchantOrderId);
          }
          break;
        }
        case "alphaPay": {
          if (!this.createOrderResponse.RequestId) return;

          if (
            data.params.success &&
            data.params.paymentRequestId ===
              this.createOrderResponse.RequestId
          ) {
            this.$emit("success", data.params.paymentRequestId);
          }
          break;
        }
      }
    },
  },
};

export default {
  name: "qrCodeViewer",
  mixins: [mixinDevice, mixin_WindowEvents],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default:
        "付款完成前请不要关闭该界面。<br />如付款完成后状态未更新请稍等片刻尝试刷新；<br />多次刷新后若状态依然未更新，请联系客服工作人员进行处理。",
    },
    data: {
      workflowId: 0,
      autonomousPaymentRecordId: null,
      paymentAmount: 0,
      tipAmount: 0,
      paymentType: null,
      product: null,
      description: null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      createOrderResponse: {},
      checkIntervalId: null,
      isPaied: false,
      resUrl: null,
    };
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.reloadVisible();
  },
  mounted() {},
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    paymentDesc() {
      return this.GLOBAL.enumPaymentType.getAttrValue(
        this.data.paymentType,
        "desc",
        String.empty
      );
    },
    paymentKey() {
      return this.GLOBAL.enumPaymentType.getAttrValue(
        this.data.paymentType,
        "key"
      );
    },
  },
  methods: {
    async createPaymentOrderToServer() {
      let workflowId = this.data.workflowId;
      let autonomousPaymentRecordId = this.data.autonomousPaymentRecordId;
      let paymentAmount = this.data.paymentAmount;
      let tipAmount = this.data.tipAmount;
      let product = this.data.product;
      let description = this.data.description;
      let data = {
        WorkflowId: workflowId,
        AutonomousPaymentRecordId: autonomousPaymentRecordId,
        PaymentAmount: paymentAmount,
        TipAmount: tipAmount,
        PaymentType: this.data.paymentType,
        Product: product,
        Description: description,
      };
      try {
        let result = await createPaymentOrder(data);
        if (!result) return;

        if (result.success) {
          this.createOrderResponse = result.data;
          if (!!this.createOrderResponse.PaymentType && this.data.paymentType !== this.createOrderResponse.PaymentType)
            this.data.paymentType = this.createOrderResponse.PaymentType;
        } else this.$message.error(result.message);
      } catch (error) {
        console.error(error);
      }
    },
    async getAlphaPayOrderRecordByWorkflowIdFromServer() {
      let workflowId = this.data.workflowId;
      try {
        let result = await getAlphaPayOrderRecordByWorkflowId(workflowId);
        if (!result || !result.success) return null;

        return result.data;
      } catch (error) {
        console.error(error);
      }
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) this.dialogVisible = newValue;
    },
    resetData() {
      this.createOrderResponse = {};
      this.clearCheckInterval();
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.$nextTick(async () => {
        await this.createPaymentOrderToServer();

        if (
          !this.createOrderResponse ||
          Object.isEmpty(this.createOrderResponse)
        )
          return;

        if (
          this.createOrderResponse.PayApiType ===
          this.GLOBAL.enumPayApiType.AlphaPay
        ) {
          this.checkIntervalId = setInterval(async () => {
            let orderRecord =
              await this.getAlphaPayOrderRecordByWorkflowIdFromServer();
            if (!orderRecord || orderRecord.PaymentStatus !== "SUCCESS") return;

            this.clearCheckInterval();
            let timestamp = new Date().valueOf();
            this.resUrl = `${orderRecord.RedirectUrl}?requestId=${orderRecord.PaymentRequestId}&status=success&timestamp=${timestamp}`;
            this.isPaied = true;
          }, 5000);
        }
      });
    },
    handleClose(done) {
      this.closeDialog();
    },
    clearCheckInterval() {
      if (!this.checkIntervalId) return;

      clearInterval(this.checkIntervalId);
      this.checkIntervalId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .icon {
    padding: 0 5px;
    width: 32px;
    height: 32px;

    img {
      vertical-align: middle;
      text-align: center;
      width: 32px;
      height: 32px;
    }
  }

  .cs-qrCodeViewer-top {
    display: table;
    margin: auto;
    font-size: 18px;

    span {
      display: inline-block;
      vertical-align: middle;
    }

    .cs-qrCodeViewer-explain {
      text-align: center;
      margin-bottom: 10px;
    }

    .cs-qrCodeViewer-tips {
      color: red;
      font-size: 14px;
    }
  }

  .cs-qrCodeViewer-main {
    text-align: center;
    overflow: hidden;

    iframe {
      width: 1440px;
      margin-top: 10px;
      margin-left: calc(-50% - 230px);

      &.checkpay-content {
        height: 600px;
      }

      &.alphaPay-content {
        height: 400px;
      }
    }
  }
}
</style>

<style lang="scss">
iframe {
  body {
    margin-left: calc(-50% - 220px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payApi/qrCodeViewer.vue